import { defineMessages } from 'react-intl';

export default defineMessages({
	lblPaymentMethod: {
		id: 'app.common.payment.method',
		defaultMessage: 'Payment Method',
	},
	lblPaymentSelect: {
		id: 'app.common.payment.select',
		defaultMessage: '--- Select Method ---',
	},
	lblPaymentCardName: {
		id: 'app.common.payment.cardName',
		defaultMessage: 'Name on card',
	},
	lblPaymentFirstName: {
		id: 'app.common.payment.FirstName',
		defaultMessage: 'First Name',
	},
	lblPaymentMiddleName: {
		id: 'app.common.payment.MiddleName',
		defaultMessage: 'Middle Name',
	},
	lblPaymentLastName: {
		id: 'app.common.payment.LastName',
		defaultMessage: 'Last Name',
	},
	lblPaymentCardNumber: {
		id: 'app.common.payment.cardNumber',
		defaultMessage: 'Card Number',
	},
	lblPaymentCardNumberFirstSixDigits: {
		id: 'app.common.payment.firstSixDigits',
		defaultMessage: 'First 6 Digits',
	},
	lblPaymentCardNumberLastFourDigits: {
		id: 'app.common.payment.lastFourDigits',
		defaultMessage: 'Last 4 Digits',
	},
	lblPaymentExpiryDate: {
		id: 'app.common.payment.expiryDate',
		defaultMessage: 'Expiry date',
	},
	lblMonth: {
		id: 'app.common.payment.month',
		defaultMessage: 'Month',
	},
	lblYear: {
		id: 'app.common.payment.year',
		defaultMessage: 'Year',
	},
	lblPaymentStartDate: {
		id: 'app.common.payment.startDate',
		defaultMessage: 'Start date',
	},
	lblPaymentIssueNumber: {
		id: 'app.common.payment.issueNumber',
		defaultMessage: 'Issue Number',
	},
	lblPaymentSecurityCode: {
		id: 'app.common.payment.securityCode',
		defaultMessage: 'Security Code',
	},
	lblPaymentSortCode: {
		id: 'app.common.payment.sortCode',
		defaultMessage: 'Sort Code',
	},
	lblEndingNumber: {
		id: 'app.common.payment.endingNumber',
		defaultMessage:
			'Payment will be made with account ending in {endingNumber}',
	},
	lblEnterVoucherDetails: {
		id: 'app.common.payment.enterVoucherDetails',
		defaultMessage: 'Enter Voucher details',
	},
	lblVoucherCode: {
		id: 'app.common.payment.voucherCode',
		defaultMessage: 'Voucher Code',
	},
	lblVoucherPin: {
		id: 'app.common.payment.voucherPin',
		defaultMessage: 'Voucher PIN',
	},
	lblCheckVoucherBalance: {
		id: 'app.common.payment.checkVoucherBalance',
		defaultMessage: 'Check voucher balance',
	},
	lblRemoveVoucher: {
		id: 'app.common.payment.removeVoucher',
		defaultMessage: 'Remove Voucher',
	},
	lblVoucherBalance: {
		id: 'app.common.payment.voucherBalance',
		defaultMessage: 'Voucher balance: {balance}',
	},
	lblVoucherBalanceGreater: {
		id: 'app.common.payment.voucherBalanceGreater',
		defaultMessage:
			'As the value of the voucher is greater than the cost of the purchase, the balance will remain on the voucher for use at a later date.',
	},
	lblVoucherBalanceLess: {
		id: 'app.common.payment.voucherBalanceLess',
		defaultMessage:
			'As the value of the voucher is less than the cost of the purchase, additional payments will be required once this payment has been submitted.',
	},
	lblVoucherIncorrect: {
		id: 'app.common.payment.voucherIncorrect',
		defaultMessage: 'Voucher code or PIN are incorrect',
	},
	lblPciTelecomPay: {
		id: 'app.common.payment.pciTelecomPay',
		defaultMessage: 'Open Payment Form',
	},
	lblPciTelecomHelpText: {
		id: 'app.common.payment.pciTelecomHelpText',
		defaultMessage: 'This will open a new tab to process the PCI Agent payment',
	},
	lblPciTelecomUrlError: {
		id: 'app.common.payment.pciTelecomUrlError',
		defaultMessage: 'Failed to get PCI Agent URL',
	},
	lblKeyIvrPay: {
		id: 'app.common.payment.keyIvrPay',
		defaultMessage: 'Open Payment Form',
	},
	lblKeyIvrHelpText: {
		id: 'app.common.payment.keyIvrHelpText',
		defaultMessage: 'This will open a new tab to process the KeyIVR payment',
	},
	lblKeyIvrUrlError: {
		id: 'app.common.payment.keyIvrUrlError',
		defaultMessage: 'Failed to get KeyIVR URL',
	},
});
